import { Skeleton } from '@wwe-portal/ui/components/skeleton';

export const RedeemCodeSkeleton = () => {
  return (
    <div className="flex items-center justify-center gap-2 xl:justify-end">
      <Skeleton className="h-8 w-[170px] rounded-[5px] p-2" />
      <Skeleton className="h-8 w-[170px] rounded-[5px] p-2" />
    </div>
  );
};
